import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { updateProfile } from "firebase/auth";

const AccountSettings = () => {
  const { currentUser } = useAuth();
  const [displayName, setDisplayName] = useState("");
  const [status, setStatus] = useState("active");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (currentUser) {
      setDisplayName(currentUser.displayName || "");
      const fetchStatus = async () => {
        const ref = doc(db, "users", currentUser.uid);
        const snap = await getDoc(ref);
        if (snap.exists() && snap.data().status) {
          setStatus(snap.data().status);
        }
      };
      fetchStatus();
    }
  }, [currentUser]);

  const handleUpdateName = async () => {
    try {
      if (!currentUser) return;
      await updateProfile(currentUser, { displayName });
      await setDoc(
        doc(db, "users", currentUser.uid),
        { displayName },
        { merge: true }
      );
      setMessage("✅ Name updated successfully.");
    } catch (err) {
      console.error(err);
      setMessage("❌ Failed to update name.");
    }
  };

  const handleDeactivate = async () => {
    try {
      await updateDoc(doc(db, "users", currentUser.uid), {
        status: "deactivated",
      });
      setStatus("deactivated");
      setMessage("⚠️ Account marked as deactivated.");
    } catch (err) {
      console.error(err);
      setMessage("❌ Failed to deactivate account.");
    }
  };

  const handleReactivate = async () => {
    try {
      await updateDoc(doc(db, "users", currentUser.uid), {
        status: "active",
      });
      setStatus("active");
      setMessage("✅ Account reactivated.");
    } catch (err) {
      console.error(err);
      setMessage("❌ Failed to reactivate account.");
    }
  };

  return (
    <main className="app-main">
    <div className="space-y-5 text-sm">
      <h2 className="text-lg font-semibold mb-2">Account Settings</h2>

      <div>
        <label className="block text-xs font-medium mb-1">Display Name</label>
        <input
          type="text"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          className="w-full border border-gray-300 rounded px-2 py-1 text-sm"
        />
        <button
          onClick={handleUpdateName}
          className="mt-2 px-4 py-2 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Update Name
        </button>
      </div>

      <div className="bg-red-50 border border-red-200 rounded p-4">
        <h3 className="font-semibold text-red-600 mb-1">Danger Zone</h3>
        {status === "active" ? (
          <>
            <p className="text-xs text-red-500 mb-2">
              Deactivating your account will hide your profile and disable access. You can reactivate later.
            </p>
            <button
              onClick={handleDeactivate}
              className="px-4 py-2 text-sm bg-red-600 text-white rounded hover:bg-red-700"
            >
              Deactivate Account
            </button>
          </>
        ) : (
          <>
            <p className="text-xs text-yellow-700 mb-2">
              Your account is currently deactivated. Reactivating will restore access.
            </p>
            <button
              onClick={handleReactivate}
              className="px-4 py-2 text-sm bg-yellow-500 text-white rounded hover:bg-yellow-600"
            >
              Reactivate Account
            </button>
          </>
        )}
      </div>

      {message && (
        <p className={`text-xs mt-2 ${message.startsWith("✅") ? "text-green-600" : "text-red-600"}`}>
          {message}
        </p>
      )}
    </div>
    </main>
  );
};

export default AccountSettings;
